import React from "react";
import { Grid, MenuItem } from "@material-ui/core";
import { SelectValidator } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAreasFisicasAction } from "../../../../actions/usuarios/areasFisicas";
import {
  FetchCategoriasReclamos,
  FetchTiposOrigenes,
  FetchTiposReclamos,
} from "../../../../actions/reclamos/reclamosActions";
import { AREAS_FISICAS } from "../../../../utils/constants";

export const ReclamoCabeceraForm = ({
  formValues,
  handleInputChange,
  setearVariosValores,
  setearValor
}) => {
  const { areasFisicas } = useSelector((state) => state.areasFisicas);
  const { areasFisicasUsuario } = useSelector((state) => state.auth);
  const { listaTipoReclamos, listaTipoOrigenes, listaCategoriasReclamos } =
    useSelector((state) => state.reclamos);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAreasFisicasAction());
    dispatch(FetchCategoriasReclamos());
    dispatch(FetchTiposOrigenes());
    dispatch(FetchTiposReclamos());
  }, [dispatch]);


  return (
    <Grid container justify="space-between" spacing={2}>
      <Grid item xs={12} md={4}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Tipo"
          name="tipoReclamo"
          //disabled={areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES}
          //value={areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES ? formValues.tipoReclamo : 1} //1 es tipo "reclamo"
          value={formValues.tipoReclamo} //1 es tipo "reclamo"
          onChange={handleInputChange}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
          style={{ color: "#000" }}
        >
          {listaTipoReclamos.map((e) => (
            <MenuItem key={e.id} value={e.id}>
              {e.descripcion}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Origen"
          name="tipoOrigen"
          value={formValues?.tipoOrigen}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          style={{ color: "#000" }}
        >
          {listaTipoOrigenes.map((e) => (
            <MenuItem key={e.id} value={e.id}>
              {e.descripcion}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Categoria"
          name="categoriaReclamo"
          disabled={false}
          value={formValues.categoriaReclamo}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          style={{ color: "#000" }}
        >
          {listaCategoriasReclamos.map((e) => (
            <MenuItem key={e.id} value={e.id}>
              {e.descripcion}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="Área Destino"
          name="destino"
          disabled={areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES}
          value={areasFisicasUsuario.idArea === AREAS_FISICAS.COMUNICACIONES ? formValues.destino : AREAS_FISICAS.COMUNICACIONES}
          onChange={(e) => {
            setearVariosValores({
              "destino": e.target.value,
              "subDestino": 0,
            });
          }}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          style={{ color: "#000" }}
        >
          {areasFisicas.map((e) => (
            <MenuItem key={e.idArea} value={e.idArea} disabled={areasFisicasUsuario.idArea !== AREAS_FISICAS.COMUNICACIONES && e.idArea !== AREAS_FISICAS.COMUNICACIONES}>
              {e.descripcionArea}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>

      <Grid item xs={12} md={4}>
        {(formValues.destino !== "") && !(areasFisicas.find(e => e.idArea === formValues.destino).subAreas.length === 0) && (
          <SelectValidator
            fullWidth
            margin="normal"
            label="Subárea Destino"
            name="subDestino"
            disabled={formValues.destino === ""} 
            value={formValues.subDestino}
            onChange={(e) => {
              setearValor("subDestino", e.target.value);
            }}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
            validators={["required"]}
            errorMessages={["Este campo es obligatorio"]}
            style={{ color: "#000" }}
          >
            {formValues.destino && areasFisicas.find(e => e.idArea === formValues.destino).subAreas.map(subArea => (
              <MenuItem key={subArea.idSubArea} value={subArea.idSubArea}>
                {subArea.descripcionSubArea}
              </MenuItem>
            ))}
          </SelectValidator>
        )
        }
      </Grid>
    </Grid>
  );
};
